/* Product tiles: Reviews.io prints "(7 Reviews)" under the stars. On a tile the
   number is enough, so it is trimmed to "(7)", and the stars stop being a button. The widget fills in after load and
   again as more tiles arrive (filters, load more), so a MutationObserver keeps
   trimming whatever it adds. The full wording stays in the widget's own
   aria-label for screen readers. */
(function () {
  function trim(root) {
    if (!root || !root.querySelectorAll) return;
    var counts = Array.prototype.slice.call(root.querySelectorAll('.product-item .ruk-rating-snippet-count'));
    if (root.matches && root.matches('.product-item .ruk-rating-snippet-count')) counts.push(root);
    for (var i = 0; i < counts.length; i++) {
      var el = counts[i];
      var m = el.textContent.match(/\((\d+)\s+reviews?\)/i);
      if (m) el.textContent = '(' + m[1] + ')';
      // Stars are not a control on a tile, so keyboard focus skips them too.
      var snippet = el.closest('.ruk_rating_snippet');
      if (snippet && snippet.getAttribute('role') === 'button') {
        snippet.removeAttribute('role');
        snippet.removeAttribute('tabindex');
      }
    }
  }
  trim(document);
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var t = records[i].target;
      trim(t.nodeType === 1 ? t : t.parentNode || document);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
